<template>
  <div>
    <!-- Breadcrumb -->
    <app-breadcrumb>
      <template #contentright>
        <b-button
          v-b-modal.showRelate1
          variant="outline-primary"
        >
          <span class="text-nowrap">
            <feather-icon icon="PlusCircleIcon" /> Đăng bài Fanpage
          </span>
        </b-button>
      </template>
    </app-breadcrumb>

    <!-- Filters -->
    <facebook-timer-list-filters
      @search="searchAll"
    />

    <!-- Table Container Card -->
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card
        no-body
        class="mb-0"
      >
        <b-table
          ref="refUserListTable"
          class="position-relative table-nowrap"
          :items="itemsData"
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          responsive
          show-empty
          empty-text="Không tìm thấy kết quả"
          :sort-desc.sync="isSortDirDesc"
        >

          <template #cell(id)="data">
            {{ data.index + 1 }}
          </template>
          <template #cell(type_social)="row">
            {{ row.item.type_social == 10 ? 'Facebook' : ( row.item.type_social == 20 ? 'Youtube' : (row.item.type_social == 30 ? 'Twitter' : 'Twitch')) }}
          </template>
          <template #cell(is_published)="row">
            {{ row.item.is_published == 1 ? 'Đã xuất bản' : ( row.item.is_published == 2 ? 'Đang chờ' : (row.item.is_published == 3 ? 'Bị lỗi' : '')) }}
          </template>
        
          <!-- Column: Actions -->
          <template #cell(actions)="row">
            <b-button
              v-if="row.item.status === 10"
              class="ml-1 btn-icon"
              size="sm"
              variant="outline-success"
              v-b-tooltip.hover
              title="Gửi duyệt"
              @click="changeStatus(row.item.id, 20, 'Gửi duyệt')"
            >
              <feather-icon icon="SendIcon" />
            </b-button>
            <b-button variant="outline-primary" :to="{ name: 'profits-show', params: { id: row.item.id } }"
              class="ml-1 btn-icon" size="sm" v-b-tooltip.hover title="Xem chi tiết">
              <feather-icon icon="EyeIcon" />
            </b-button>
        

            <!-- v-if="$can('articleType.destroy', 'ArticleType')" -->
            <!-- <b-button
            v-if="row.item.status === 10 || row.item.status == 40"
              size="sm"
              class="btn-icon ml-1"
              variant="outline-danger"
              @click="confirmDelete(row.item.id)"
            >
              <span class="text-nowrap">
                <feather-icon icon="TrashIcon" />
              </span>
            </b-button> -->
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">{{ $t('show_to_entries', {
                from: dataMeta.from, to: dataMeta.to, of: dataMeta.of
              })
              }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                v-model="currentPage"
                :total-rows="totalEntries"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </b-overlay>
    <b-modal
      id="showRelate1"
      body-class=" mb-2"
      size="lg"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      hide-footer
      title="Đăng bài Fanpage"
      @close="dialog"
    >
      <post-page
        @updateData="handleDialog"
      />
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  required, email, alphaNum, min, max,
} from '@validations';
import {
  BOverlay,
  BCard,
  BCardBody,
  BRow,
  BCol,
  BButton,
  BTable,
  BFormCheckbox,
  BBadge,
  BPagination,
  BModal,
  BFormGroup,
  BFormTextarea,
  BFormInput,
  BForm,
  BFormInvalidFeedback,
  VBTooltip,
  BProgress,
  BProgressBar,
  BImg, BMedia, BMediaBody, BMediaAside, BAvatar, BAvatarGroup,
} from 'bootstrap-vue';
import { ref } from '@vue/composition-api';
import { showToast } from '@/@core/utils/utils';
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue';
import formValidation from '@core/comp-functions/forms/form-validation';
import store from '@/store';
// import RegisterPlanEdit from './RegisterPlanEdit.vue';
import vSelect from 'vue-select';
import Ripple from 'vue-ripple-directive';
import SocketioService from '@/libs/socketio.service';
import useJwt from '@/auth/jwt/useJwt';
import moment from 'moment';
import AppTimelineItem from './AppTimelineItem.vue'
import AppTimeline from './AppTimeline.vue'
import usePostWait from './usePostWait';
import FacebookTimerListFilters from './FacebookTimerListFilters.vue';
import PostPage from './PostPage.vue';

export default {
  components: {
    AppBreadcrumb,
    FacebookTimerListFilters,
    BOverlay,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BButton,
    BTable,
    BBadge,
    BPagination,
    BFormCheckbox,
    BModal,
    BFormGroup,
    BFormTextarea,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
    BForm,
    BFormInvalidFeedback,
    vSelect,
    BProgress,
    BProgressBar,
    AppTimeline,
    AppTimelineItem,
    BImg,
    BMedia,
    BMediaBody,
    BMediaAside,
    BAvatar,
    BAvatarGroup,
    PostPage,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      editMode: false,
      dataEdit: {},
    };
  },
  setup() {
    /** Socket cho 1 page */
    // const ac = useJwt.getToken()
    // SocketioService.setupSocketConnection(ac);
    // SocketioService.socket.on('connect', () => {
    //   console.log('Connected to server');
    //   const message = 'Helo from client';

    //   store.commit('socketio/SOCKET_CONNECT');
    //   store.commit('socketio/SOCKET_MESSAGECHANNEL', message);

    //   // this.socket.emit('send-message', { token: accessToken });
    // });
    // SocketioService.socket.on('send-message', (message) => {
    //   console.log('user_id', useJwt.getUser().id)
    //   console.log('socket on message', message);
    //   showToast(message)
    // });
    // SocketioService.socket.on('disconnect', () => {
    //   console.log('Disconnected from server');
    //   store.commit('socketio/SOCKET_DISCONNECT');
    // });

    const isAddNewUserSidebarActive = ref(false);
    const blankData = {
      id: null,
      name: '',
      manufacture_id: null,
      description: '',
    };
    const frmData = ref(JSON.parse(JSON.stringify(blankData)));
    const resetfrmData = () => {
      frmData.value = JSON.parse(JSON.stringify(blankData));
    };
    const dataStream = ref({
      input_id: '',
      streaming: {
        channel1: false,
        channel2: false,
        channel3: false,
      },
    })

    const {
      loading,
      fetchAll,
      tableColumns,
      perPage,
      currentPage,
      totalEntries,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      itemsData,
      posts,
      resolveStatusVariant,
      resolveStatusText,
      statusFilter,
      loadMore,
    } = usePostWait();

    fetchAll();

    const { refFormObserver, getValidationState, resetForm } = formValidation(frmData);

    return {
      fetchAll,
      // Sidebar
      isAddNewUserSidebarActive,
      loading,
      tableColumns,
      perPage,
      currentPage,
      totalEntries,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      itemsData,
      frmData,
      getValidationState,
      resetfrmData,
      resolveStatusVariant,
      resolveStatusText,
      statusFilter,
      dataStream,
      posts,
      loadMore,
    };
  },
  methods: {
    handleDialog() {
      this.$bvModal.hide('showRelate1');
      this.fetchAll();
      this.resetfrmData();
    },
    close() {
      this.$bvModal.hide('showRelate1');
      this.fetchAll();
      this.resetfrmData();
    },
    dialog() {
      this.editMode = false;
      this.resetfrmData();
      this.$bvModal.show('showRelate1');
    },
    edit(item) {
      console.log(item)
      this.dataEdit = item;
      // this.editMode = true;
      this.$bvModal.show('showRelate1');
    },

    changeStatus(id, status, msg, title) {
      this.$swal({
        title: title || 'Bạn chắc muốn thay đổi trạng thái?',
        text: msg,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Có',
        cancelButtonText: 'Không',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          console.log(id, status);
          this.$store
            .dispatch('registerPlan/changeStatus', { id, status })
            .then((res) => {
              if (res.status === 200) {
                this.fetchAll();
                showToast(res.data.message, { variant: 'success' });
              } else {
                showToast(res.data.message);
              }
            });
        }
      });
    },

    searchAll(data) {
      console.log('data_', data);
      this.searchQuery.keyword = data.keyword;
      this.searchQuery.end_date = data.end_date;
      this.searchQuery.status = data.status;
      this.searchQuery.channel_id = data.channel_id;
      this.fetchAll();
    },
    loadMoreItem(data) {
      console.log('data_', data);
      this.loading = true;
      store
        .dispatch('social/fetchAllFacebook', {
          accesstokenLoadMore: data,

        })
        .then((response) => {
          this.loading = false;
          console.log('res', response)
          if (response.status === 200) {
            const values = response.data.data;
            // totalEntries.value = total;
            // itemsData.value = items;
            // posts.value = itemsData.value.posts.data;
            console.log('response.data.paging.next', response.data.paging.next)
            if (response.data.paging.next !== undefined) {
              this.loadMore = response.data.paging.cursors.after;
            } else {
              this.loadMore = ''
            }
            console.log('loadMore', this.loadMore)
            this.posts = [...this.posts, ...values]
          }
        });
    },
    randomColor() {
      const months = ['primary', 'danger', 'warning', 'info', 'success', 'secondary'];
      const random = Math.floor(Math.random() * months.length);
      return months[random]
    },
    formatTime(time) {
      return moment(time).lang('vi').format('DD-MM-YYYY HH:mm')
    },

  },
};
</script>
<style lang="scss">
  .listItem {
    .card {
      width: 11%;
    }
  }
  @media (max-width: 768px) {
    .listItem {
      .card {
        width: 45%;
      }
    }
  }
  .backgroundItemActive {
    background: aliceblue;
  }
</style>
